<template>
    <the-table header="تراکنش ها" icon="Transactions" :tabs="tabs" :columns="columns" :items="items">
        <template #cell(icon)="{item}">
            <span class="d-flex-r-jc-ac">
                <inline-svg width="21" :src="require(`@/assets/Icons/${item.type}-icon.svg`)"/>
            </span>
        </template>
        <template #cell(status)="{item}">
            <span class="d-flex-r-jc-ac" :style="{'color' : `var(--${statusColor(item.status)})`}">
                <li><span>{{statusLabel(item.status)}}</span></li>
            </span>
        </template>
    </the-table>
</template>

<script>
    import TheTable from "@/components/Tools/TheTable";
    export default {
        name: "Transactions",
        components: {TheTable},
        data() {
            return {
                tabs: [
                    // {
                    //     name: 'all',
                    //     label: 'همه'
                    // },
                    {
                        name: 'withdraw',
                        label: 'واریز'
                    },
                    {
                        name: 'deposit',
                        label: 'برداشت'
                    },
                ],
                columns:[
                    {
                        name : 'icon',
                        label : '',
                    },
                    {
                        name : 'createdAtDateTime',
                        label : 'زمان',
                        type : 'date',
                        dateType : 'faDateTime',
                        mobile: true
                    },
                    {
                        name : 'relatedCoin',
                        label : 'رمزارز',
                        mobile:true
                    },
                    {
                        name : 'amount',
                        label : 'مقدار',
                        type: 'number',
                        mobile: true
                    },
                    {
                        name : 'wagePercent',
                        label : 'کارمزد',
                    },
                    {
                        name : 'hash',
                        label : 'شناسه تراکنش',
                    },
                    {
                        name : 'status',
                        label : 'وضعیت',
                        mobile: true
                    },
                ],
                items:[
                    {
                        amount : 0.008,
                        createdAtDateTime : '2021-08-02T15:12',
                        relatedCoin : 'بیتکوین',
                        wagePercent : '0.4%',
                        hash : '2sdf65sd4f56sd4f65sd4f65ds4',
                        status : 'COMPLETED',
                        type:'WITHDRAW'
                    },
                    {
                        amount : 0.008,
                        createdAtDateTime : '2021-08-02T15:12',
                        relatedCoin : 'بیتکوین',
                        wagePercent : '0.4%',
                        hash : '2sdf65sd4f56sd4f65sd4f65ds4',
                        status : 'DENIED',
                        type:'DEPOSIT'
                    },
                    {
                        amount : 0.008,
                        createdAtDateTime : '2021-08-02T15:12',
                        relatedCoin : 'بیتکوین',
                        wagePercent : '0.4%',
                        hash : '2sdf65sd4f56sd4f65sd4f65ds4',
                        status : 'PENDING',
                        type:'WITHDRAW'
                    },
                    // {
                    //     amount : 0.008,
                    //     createdAtDateTime : '2021-08-02T15:12',
                    //     relatedCoin : 'بیتکوین',
                    //     wagePercent : '0.4%',
                    //     hash : '2sdf65sd4f56sd4f65sd4f65ds4',
                    //     status : 'DENIED',
                    //     type:'DEPOSIT'
                    // },
                ]
            }
        },
        computed:{
            statusLabel(){
                const a = {
                    'COMPLETED' : 'موفق',
                    'DENIED' : 'نا موفق',
                    'PENDING' : 'درحال بررسی',
                }
                return e => a[e]
            },
            statusColor(){
                const a = {
                    'COMPLETED' : 'buy',
                    'DENIED' : 'sell',
                    'PENDING' : 'yellow3',
                }
                return e => a[e]
            },
        }
    }
</script>

<style lang="scss" scoped>
    li{
        list-style-type : '●';
        span{
            position: relative;
            right: 1ch;
        }
    }
</style>